import ReportQAPreview from './ReportQAPreview';
export default ReportQAPreview;
